<template>
  <div>
    <template v-if="!isError">
      <slot v-bind="{ item }"></slot>
    </template>
    <template v-else>
      {{ $t('this_message_was_replied_from_ads', { ad_id: adId }) }}
    </template>
    <template v-if="errorMessages">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon small color="red" v-on="on"> info </v-icon>
        </template>
        <span>{{ errorMessages }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    adId: {}
  },
  data() {
    return {
      item: null,
      isError: false,
      errorMessages: ''
    }
  },
  async mounted() {
    if (this.adId) {
      this.item = await this.handleGetAdsDetail()
    }
  },
  methods: {
    async handleGetAdsDetail() {
      this.errorMessages = ''
      try {
        const response = await axios.get(`https://graph.facebook.com/v13.0/${this.adId}`, {
          params: {
            fields: 'name,creative{title}',
            access_token: this.$store.state.selectedBot.page_access_token
          }
        })
        if (response.data) {
          return response.data
        } else {
          if (response.error && response.error.message) {
            this.errorMessages = response.error.message
          }
          return {}
        }
      } catch (error) {
        if (error.response.data && error.response.data.error && error.response.data.error.message) {
          this.errorMessages = error.response.data.error.message
        }
        this.isError = true
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/AdsData.vue